exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-overlay {\n    left: 0;\n    top: 0;\n    position: fixed;\n    z-index: 1031;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255,255,255,0.7);\n    opacity: 1;\n}\n\n.loading-overlay div {\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-image: url(/assets/img/loading-spinner.gif);\n    background-position: 50% 50%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/spinner/spinner.component.css
// module id = 1069
// module chunks = 1